export const iconFontAwesomeHandsHandBackFist = (
	<i className="fa-solid fa-hand-back-fist"></i>
);
